import { put } from "@redux-saga/core/effects";
import axios from "axios";

import { AuthService, OAuthFlowGetCodeRequest } from "../../../services/auth";
import { IErrorType } from "../../types/errors.d";
import { oauthFlowFailure, oauthFlowSuccess } from "../actionCreators";
import { OAuthFlowRequestActionType } from "../types";

export function* oauthFlowSaga({
    payload: { email, password, client_id, redirect_url, state, scope },
}: OAuthFlowRequestActionType) {
    try {
        yield AuthService.checkUser(email, password);
        const {
            data: { redirect_uri },
        }: OAuthFlowGetCodeRequest = yield AuthService.getRedirectUrl({
            client_id,
            email,
            password,
            redirect_url,
            state,
            scope,
        });
        yield put(oauthFlowSuccess({ url: redirect_uri }));
    } catch (error) {
        let errorType = IErrorType.NATIVE;
        let errorData = error;

        if (axios.isAxiosError(error)) {
            errorType = IErrorType.AXIOS;
            errorData = error.response ? error.response.data : null;
        }

        yield put(oauthFlowFailure({ errorType, data: errorData }));
    }
}
